export const Config = {
  "API_URL": 'https://garage-api.abocar.at/',
  "FILE_MAX_SIZE_KB": 10240,
  "INTERNAL_OWNERSHIP_CHANGE": "OWNERSHIP_CHANGE:",
}
